// extracted by mini-css-extract-plugin
module.exports = {"wtc3d9c":"wtc3d9c"};